import React, { Component } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Autoplay, Thumbs, Mousewheel } from 'swiper/modules';
import styled from 'styled-components';
import { ChevronLeft, ChevronRight } from "lucide-react";
import * as LucideIcons from "lucide-react";
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import BannerSlider from 'components/BannerSlider';
import GameCards from 'pages/Parts/Home/GameCards';
import Register from 'pages/Auth/Register';
import Banner from 'components/Banner';
import DynamicGroupSwiper from 'components/DynamicGroupSwiper';
import { useGameEngine, getGameImage } from "hooks/useGameEngine";
import GroupPage from 'pages/GroupPage';
import { useActiveGroups } from 'hooks/useGameEngine';

const GridContainerNew = styled.div`
  gap: 5px;
  width: 100%;
  height:100%;
  display: flex;
  overflow: hidden;
  padding: 0 0.5rem;
  padding-top:2.2rem;

  justify-content: center;
  align-items: center;
`;

const GridItem = styled.div`
  background-color: transparent;
  width: 100%;
  border-radius: 10px;

  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative; /* Needed for the play icon */
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;

  /* For image */
  .swiper-slide-img {
    transition: opacity 0.3s ease; /* Smooth transition for image opacity */
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.4); /* Background color on hover */
  }

  &:hover .swiper-slide-img {
    opacity: 0.3; /* Reduce opacity of the image on hover */
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px; /* Adjust icon size */
    color: white;
    opacity: 0;
   
    padding:13px;
    justify-item:center;
    text-align:center;
    background-color:#0009;
    border-radius:100%;
    transition: opacity 0.3s ease;
  }

  &:hover .play-icon {
    opacity: 1; /* Show play icon on hover */
  }
    
`;


const GridItemprovider = styled.div`
  background-color:#292d2e;
  width: 100%;
  border-radius: 10px;
  padding:9px 12px;

  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative; /* Needed for the play icon */
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;

  /* For image */
  .swiper-slide-img {
    transition: opacity 0.3s ease; /* Smooth transition for image opacity */
  
    }

  &:hover {
  cursor:pointer;
    }

  &:hover .swiper-slide-img {
    opacity: 0.3; /* Reduce opacity of the image on hover */
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px; /* Adjust icon size */
    color: white;
    opacity: 0;
   
    padding:13px;
    justify-item:center;
    text-align:center;
    background-color:#0009;
    border-radius:100%;
    transition: opacity 0.3s ease;
  }

  &:hover .play-icon {
    opacity: 1; /* Show play icon on hover */
  }
    
`;
const GamesSlotWrapper = styled.div`
  border-radius: 0 20px 20px 20px; /* top-left | top-right | bottom-right | bottom-left */
  margin-top: 40px !important;
`;

const ResponsiveImage = styled.img`
  object-fit: cover;
  width: 100%;  // Adjusts image width to fill the container
  height: auto; // Maintains aspect ratio for responsiveness

 

  @media (min-width: 467px) {
    width: 100%;
    height: auto;
    
  }
`;

const AllButtonRigthTitleContainer = styled.div`

  position: absolute;
  display:flex;
  gap:10px;
  width:100%;
  align-items:center;
 justify-content:space-between;
  top: -34px; //vivek
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  margin: 0;
`;

const AllButtonTopTitleContainer = styled.div`
  background-color: #1C1E22;
  border-radius: 15px;
  display:flex;
  justify-content:center;
  align-items:center;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  padding: 5px 20px;
  margin: 0;
  cursor:pointer;

  @media (max-width: 350px) {
    display:none;
  }
`;
const PaginationButton = styled.div`
  background-color: #1C1E22;
  border-radius: 50%;
  display:flex;
  justify-content:center;
  align-items:center;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  padding: 5px;

`;

class MyComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exampleState: 'Hello, React!',
      searchQuery: '',
      tempSearchQuery: '',
      selectedFilter: "all",
      games: [],
      visibleSwipersCount: 3,
      phase: "idle"
    };
    this.swiperRef = React.createRef();
    this.swiperRef8 = React.createRef();
    this.searchTimeout = null;
  }
  componentDidMount() {
    this.handleRouteChange();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.handleRouteChange();
    }
  }

  handleRouteChange() {
    const match = this.props.match;
    const slug = (match && match.params && match.params.slug) || (match && match.params && match.params.category);
    if (slug) {
      this.handleFilterChange(slug);
    } else {
      this.handleFilterChange("all");
    }
    this.setState({ visibleSwipersCount: 3 });
  }


  // Custom method for next slide
  nextSlideHandler = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext();
    }
  };

  // Custom method for previous slide
  prevSlideHandler = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev();
    }
  };


  nextSlideHandler8 = () => {
    if (this.swiperRef8.current && this.swiperRef8.current.swiper) {
      this.swiperRef8.current.swiper.slideNext();
    }
  };

  // Custom method for previous slide
  prevSlideHandler8 = () => {
    if (this.swiperRef8.current && this.swiperRef8.current.swiper) {
      this.swiperRef8.current.swiper.slidePrev();
    }
  };

  handleSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ tempSearchQuery: value });

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (!value.trim()) {
      this.setState({ searchQuery: '', phase: 'idle' });
      return;
    }

    this.setState({ phase: 'loading' });
    this.searchTimeout = setTimeout(() => {
      this.setState({ searchQuery: value.trim(), phase: 'results' });
    }, 600);
  };

  handleSearchKeyPress = (e) => {
    if (e.key === "Enter" && this.state.searchQuery !== this.state.tempSearchQuery) {
      this.setState({ searchQuery: this.state.tempSearchQuery });
    }
  };





  handleFilterChange = (category) => {
    this.setState({ selectedFilter: category });
  };



  render() {
    const { searchQuery, selectedFilter } = this.state;
    const { pathname } = this.props.location ?? {};

    const { groups } = this.props;

    const dynamicTabs = groups
      .filter(g => g.show_as_tab_casino)
      .map(g => ({
        key: g.slug || g.id,
        label: g.name,
        icon: g.icon || 'hotGames.svg',
        path: `/casino/${g.slug || g.id}`
      }));

    const categories = [
      { key: 'all', label: 'Lobby', icon: 'lobby.svg', path: '/casino' },
      ...dynamicTabs,
      { key: 'providers', label: 'Providers', icon: 'lobby.svg', path: '/casino/providers' }
    ];

    return (
      <div>
        {/* header image */}
        <BannerSlider type="casino" />
        <GameCards />

        <div className="casino-container" >
          {/* Search Bar */}
          <div className="search-container">
            <img
              src="/assets/bcimages/Casino/svgexport-1 (1).svg"
              alt="search"
              className="search-icon"
            />
            <input
              type="text"
              value={this.state.tempSearchQuery} // Use tempSearchQuery for real-time typing
              onChange={this.handleSearchChange}
              onKeyDown={this.handleSearchKeyPress}
              placeholder="Search games"
              className="search-input"
            />
          </div>

          <div className="filter-buttons mt-5" >
            {categories.map(({ key, label, icon, path }) => {
              const isActive =
                (key === 'all' && (pathname === '/casino' || !categories.some((cat) => pathname.includes(cat.key)))) ||
                pathname.includes(key);

              const isLucideIcon = typeof icon === 'string' && LucideIcons[icon];
              return (
                <Link key={key} to={path}>
                  <div
                    className={`filter-button ${isActive ? 'active' : ''}`}
                    onClick={() => this.handleFilterChange(key)}
                  >
                    {isLucideIcon ? (
                      React.createElement(LucideIcons[icon], {
                        size: 20,
                        className: "filter-btn-img",
                        style: { color: "inherit", width: "20px", height: "20px" }
                      })
                    ) : (
                      <img src={`/assets/bcimages/Casino/${icon}`} className="filter-btn-img" />
                    )}
                    {label}
                  </div>
                </Link>
              );
            })}
          </div>

          {selectedFilter !== 'all' ? (
            <GroupPage groupSlug={selectedFilter} hideBanner={true} isLobbyTab={true} lobbySearchQuery={searchQuery} />
          ) : (
            <div>
              {this.state.phase === 'loading' && (
                <div style={{ display: 'grid', placeItems: 'center', padding: '80px 0' }}>
                  <div style={{ width: '48px', height: '6px', backgroundColor: '#0f212e', borderRadius: '99px', overflow: 'hidden' }}>
                    <div style={{ height: '100%', width: '33%', backgroundColor: 'rgba(255,255,255,0.7)', animation: 'pulse 1.5s ease-in-out infinite' }} />
                  </div>
                </div>
              )}
              {this.state.phase !== 'loading' && (
                <>
                  {searchQuery ? (
                    <div>
                      <div style={{ color: '#fff', fontSize: '20px', fontWeight: 'bold', margin: '20px 0' }}>
                        Search Results for "{searchQuery}"
                      </div>
                      <GlobalSearchResults searchQuery={searchQuery} />
                    </div>
                  ) : (
                    <GamesSlotWrapper>
                      {this.props.groups
                        .filter((group) => group.show_on_home_casino)
                        .slice(0, this.state.visibleSwipersCount)
                        .map((group) => (
                          <DynamicGroupSwiper
                            key={group.id}
                            group={group}
                            prefix="/casino/group/"
                          />
                        ))}
                    </GamesSlotWrapper>
                  )}

                  {this.props.groups.filter((group) => group.show_on_home_casino).length > this.state.visibleSwipersCount && !searchQuery && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                      marginTop: '32px',
                      marginBottom: '32px',
                      width: '100%',
                      padding: '0 20px'
                    }}>
                      <div style={{ flex: 1, height: '1px', backgroundColor: 'rgba(255, 255, 255, 0.05)' }} />
                      <button
                        onClick={() => this.setState(prev => ({ visibleSwipersCount: prev.visibleSwipersCount + 3 }))}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#9ca3af',
                          fontSize: '13px',
                          fontWeight: '900',
                          letterSpacing: '0.15em',
                          textTransform: 'uppercase',
                          cursor: 'pointer',
                          transition: 'color 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.color = '#ffffff'}
                        onMouseOut={(e) => e.target.style.color = '#9ca3af'}
                      >
                        LOAD MORE
                      </button>
                      <div style={{ flex: 1, height: '1px', backgroundColor: 'rgba(255, 255, 255, 0.05)' }} />
                    </div>
                  )}
                </>
              )}
            </div>
          )}






        </div>
      </div>
    );
  }
}

function GlobalSearchResults({ searchQuery }) {
  const { data: games, isLoading } = useGameEngine({ search: searchQuery, limit: 100 });

  if (isLoading) return <div style={{ color: '#94a6b5' }}>Searching...</div>;
  if (!games || games.length === 0) return <div style={{ color: '#ff5a7a' }}>No games found.</div>;

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
      gap: '12px'
    }}>
      {games.map((g, i) => (
        <div key={i} style={{ backgroundColor: '#292d2e', borderRadius: '8px', overflow: 'hidden', position: 'relative', aspectRatio: '3/4' }}>
          <a href={`/play/${g.id}`}>
            <img src={getGameImage(g)} alt={g.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </a>
        </div>
      ))}
    </div>
  );
}

export function CasinoWrapper(props) {
  const { data: groups } = useActiveGroups();
  return <MyComponent {...props} groups={groups || []} />;
}

export default withRouter(CasinoWrapper);
